import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const ManualTextsBatchesListPage = lazy(() =>
  import('src/sections/manager/manual-text-messages/manual-text-batches-list')
);
const ManualTextsBatchViewPage = lazy(() =>
  import('src/sections/manager/manual-text-messages/manual-text-batches-view')
);
const ManualTextsBatchCreatePage = lazy(() =>
  import('src/sections/manager/manual-text-messages/manual-text-batches-create')
);

export const adminToolsRoutes = [
  {
    path: 'admin-tools',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'manual-text-messages', element: <ManualTextsBatchesListPage />, index: true },
      {
        path: 'manual-text-messages/create',
        element: <ManualTextsBatchCreatePage />,
        index: true,
      },
      {
        path: 'manual-text-messages/:textMessageBatchId/view',
        element: <ManualTextsBatchViewPage />,
      },
    ],
  },
];
